module.exports = __webpack_public_path__ + "static/pemalex_img_fabrica_h-68f315eafb90dbb066b5068213548a41.jpg";